import { callApi } from "../utils/apiUtils";
import { report } from "./endpoints/report";

export const getPre16Reports = ({ query, pathParams }) =>
  callApi({ uriEndPoint: report.getPre16Reports.v1, query, pathParams });

export const getPost16Reports = ({ query, pathParams }) =>
  callApi({ uriEndPoint: report.getPost16Reports.v1, query, pathParams });
